import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuctionDetailsComponent } from './auction-details/auction-details.component';
import { PrimengModule } from '../global/primeng.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { ListboxModule } from 'primeng/listbox';
import { ChangeLogDetailsComponent } from './change-log-details/change-log-details.component';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  declarations: [AuctionDetailsComponent, ChangeLogDetailsComponent],
  imports: [
    CommonModule,
    PrimengModule,
    SharedModule,
    FormsModule,
    DropdownModule,
    ReactiveFormsModule,
    TooltipModule,
    CalendarModule,
    ListboxModule,
    DialogModule
  ], exports: [AuctionDetailsComponent]
  , entryComponents: [AuctionDetailsComponent]
})

export class AuctionModule { }